"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GStreetViewHelp = /** @class */ (function () {
    function GStreetViewHelp() {
    }
    GStreetViewHelp.initialize = function (element, data) {
        var panorama = new google.maps.StreetViewPanorama(element, {
            position: {
                lat: data.lat,
                lng: data.lng,
            },
            pov: {
                heading: data.heading,
                pitch: data.pitch,
            },
            zoom: data.zoom,
            scrollwheel: false
        });
        return panorama;
    };
    ;
    return GStreetViewHelp;
}());
exports.default = GStreetViewHelp;
//# sourceMappingURL=GStreetViewHelp.js.map